<!-- eslint-disable max-lines -->
<template>
    <div id="mPanel4" style="height:100%">
        <m-search-list :popPrefix="popPrefix" ref="searchList" :initSearchInfo="initSearchInfo"
                       :searchId="searchId" :list="config.searchList" :searchTotalTitle="searchTotalTitle" :optionNum="optionNum"
                       :configurationUrl="configurationUrl" :longPrefix="longPrefix" :advancePrefix="advancePrefix" :searchSetTitle="searchSetTitle"
                       @onSearchChange="searchChange" @tableAdvance="tableAdvance">
          <span slot="search-list-advance-right">
              <slot name="search-list-advance-right"></slot>
          </span>
          <div slot="table-module-btn" class="btn-box">
            <slot name="table-module-btn"></slot>
            <el-tooltip v-if="config.configuration?false: true" class="item allocation-box" effect="dark" content="列配置" placement="bottom">
              <el-button size="mini" class="el-icon-setting" @click="getTitleList"></el-button>
            </el-tooltip>
            <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
              <configuration :checkedList="checkedList" :selectAllColumns="config.table.columns" ref="dialog"
                             @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
            </el-dialog>
          </div>
        </m-search-list>
        <div slot="table-top">
            <slot name="table-top"></slot>
        </div>
        <div class="all-table">
            <div class="all-table-left" ref="allTableLeft">
                <div class="lr-drag" ref="lrDragWidth" @mousedown.stop.prevent="mousedownLRWidth"></div>
                <div class='list-top' v-if="config.table.seperateTree">
                    <div class="list-title title list-title-top">
                        <span>{{sourceTitle}}</span>
                        <span class="title-count">
                            <div v-if="sourceCount">{{ sourceCount.split('/')[0] }}</div>
                            <div v-if="sourceCount">{{ sourceCount.split('/')[1] }}</div>
                        </span>
                    </div>
                    <ul class='table-lists' ref="topLists"><el-main v-loading="sourceTreeLoading">
                        <el-scrollbar>
                        <li class="list-details" v-for="(item, index) in sourceRootData" :key="index"
                            :class="{ 'active': mulSourceSel ? item.isActive : 'source'+index == sourceCurrent}"
                            @click="rootListClick(item, 'source', index)">{{item.textLeft}}</li>
                        </el-scrollbar>
                    </el-main></ul>
                </div>
                <div class='list-bottom' v-if="config.tableTarget.seperateTree">
                    <div class="list-drag" ref="listDragHeight" @mousedown.stop.prevent="mousedownlistDragHeight"></div>
                    <div class="list-title" :class="isRefreshTarget ? 'target-list' : ''" @click="refreshTarget">{{targetTitle}}</div>
                    <span class="table-input">
                        <el-input v-show="isCondition" @keyup.enter.native="searchInput" v-model="input" clearable :placeholder="config.tableTarget.funnelPlaceholder"
                        @clear="searchInput" class="funnel-placeholder"></el-input>
                        <img v-show="isShowImg" @click="showInput" class="table-img" src="@/assets/漏斗@2x.png" alt="">
                    </span>
                    <ul class='table-lists' ref="bottomLists"><el-main v-loading="targetTreeLoading">
                        <el-scrollbar>
                            <li class="list-details" v-for="(item, index) in targetRootData" :key="index"
                                :class="{ 'active': 'target'+index == targetCurrent,
                                'toBeConfirm': (item.intelligentStatus == '10' || (item.intelligentStatus == '30' && item.intelligentFlag == '10')) }"
                                @click="rootListClick(item, 'target', index)"
                                v-html="item.html"></li>
                        </el-scrollbar>
                    </el-main></ul>
                </div>
            </div>
            <div class="all-table-right" ref="allTableRight">
                <m-table
                    ref="table"
                    class="source-table"
                    :popPrefix="popPrefix"
                    :longPrefix="longPrefix"
                    :verification="verification"
                    :tableConfig="config.table"
                    :tableData="totalData"
                    :tableList="tableList"
                    :loading="sourceLoading"
                    @tab-advanced-search="tabAdvancedSearch"
                    @row-db-click="rowDBClick"
                    @save-data="saveData"
                    @btnView="checkTable"
                    @btnEdit="editTable"
                    @btnPrint="printTable"
                    @btnDelete="delTable"
                    @btnAllocate="allocateTable"
                    @btnCancleAllocate="cancleAllocateTable"
                    @onSelectionChange="sourceSelectChange"
                    @switch-change="switchChange"
                    @column-filter-search="columnFilterSearch"
                    @moreAction="moreAction"
                    @onCellDblclick="sourceCellDblclick"
                    @row-click="sourceRowClick"
                    @select="sourceSelect"
                    @selectAll="sourceSelectAll"
                >
                    <div slot="expand-table-content" slot-scope="{expandProps}"><slot name="expand-table-cont" :expandTable="expandProps"></slot></div>
                </m-table>
                <div class="table-header">
                    <slot name="target-table-header"></slot>
                    <m-table
                        ref="targetTable"
                        class="target-table"
                        :popPrefix="popPrefix"
                        :longPrefix="longPrefix"
                        :verification="verification"
                        :tableConfig="config.tableTarget"
                        :tableData=totalTargetData
                        :tableList="tableList"
                        :loading="targetLoading"
                        @tab-advanced-search="tabAdvancedSearch"
                        @row-db-click="rowDBClick"
                        @row-click="targetRowClick"
                        @select="targetSelect"
                        @selectAll="targetSelectAll"
                        @save-data="saveData"
                        @btnView="checkTable"
                        @btnEdit="editTable"
                        @btnPrint="printTable"
                        @btnDelete="delTable"
                        @onSelectionChange="targetSelectChange"
                        @switch-change="switchChange"
                        @column-filter-search="columnFilterSearch"
                        @moreAction="moreAction"
                        @onCellDblclick="targetCellDblclick"
                    >
                        <div slot="expand-table-content" slot-scope="{expandProps}"><slot name="expand-table-cont" :expandTable="expandProps"></slot></div>
                    </m-table>
                    <slot class="target" name="target-table-right"></slot>
                </div>
            </div>
        </div>
        <el-row type="flex" class="row-bg" justify="space-between" v-if="!config.transferTables">
          <el-col :span="12" class="page-text">
              <div v-if="config.table.selectBtn">
                已选<span class="text-color">&nbsp;&nbsp;{{checkedNum}}&nbsp;&nbsp;</span>项
              </div>
              <slot name="page-module-btn"></slot>
          </el-col>
          <el-col :span="12" v-if="!config.transferTables">
            <m-page ref="page" :pageData="config.page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
          </el-col>
        </el-row>
    </div>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

// import mSearchList from '@/components/otpPanel/mSearchList';
import mSearchList from '../mulitPanel/mSearchList';
import mTable from '@/components/otpPanel/mTable';
import mPage from '@/components/awesome/page/mPanel3/mPage';
import configuration from '@/components/awesome/page/mPanel3/configuration-list';
import getList from '@/components/awesome/page/mPanel3/api';
import { mapGetters } from 'vuex';

export default {
    name: 'mPanel',
    components: { mTable, mSearchList, mPage, configuration },
    computed: {
        ...mapGetters(['menus'])
    },
    data() {
        return {
            isCondition: false,
            isShowImg: true,
            input: '',
            sourceCurrent: '',
            targetCurrent: '',
            checkedNum: 0,
            startMove: 0,
            endMoveWidth: 0,
            endListMoveHeight: 0,
            showModal: false,
            tableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: '',
            targetLoading: false,
            sourceLoading: false,
            sourceTreeLoading: false,
            targetTreeLoading: false
        };
    },
    props: {
        config: Object,
        totalData: Array,
        totalTargetData: Array,
        sourceRootData: Array,
        targetRootData: Array,
        pageTotal: Number,
        sourceTitle: String,
        sourceCount: String,
        targetTitle: String,
        dataSourceUrl: String,
        pageID: String,
        searchId: String,
        optionNum: String,
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        method: {
            type: String,
            default: 'get'
        },
        searchTotalTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        endMoveHeight: {
            type: Number,
            default() {
                return 0;
            }
        },
        columnNum: Number,
        mulSourceSel: Boolean,
        isRefreshTarget: {
            type: Boolean,
            default: false
        },
        initSearchInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.path) {
                            this.resourceCode = childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        showInput() {
            this.isShowImg = false;
            this.isCondition = true;
        },
        // 漏斗切换搜索事件
        searchInput(ev, isClick) { // isClick 用于调度中心 activated 钩子
            this.$emit('search-input', this.input, ev, isClick);
        },
        // 表格中按钮触发事件
        checkTable(data) {
            this.$emit('check-btn', data);
        },
        editTable(data) {
            this.$emit('edit-btn', data);
        },
        printTable(data) {
            this.$emit('print-btn', data);
        },
        delTable(data) {
            this.$emit('del-btn', data);
        },
        allocateTable(data) {
            this.$emit('allocate-btn', data);
        },
        cancleAllocateTable(data) {
            this.$emit('cancleAllocate-btn', data);
        },
        saveData(data) {
            this.$emit('saveData', data);
        },
        // 表单选项变化
        sourceSelectChange(data) {
            this.$emit('source-select-change', data);
            this.checkedNum = data.length;
        },
        targetSelectChange(data) {
            this.$emit('target-select-change', data);
            this.checkedNum = data.length;
        },
        switchChange(data) {
            this.$emit('switch-change', data);
        //  表格内switch切换
        },
        rowDBClick(row) {
            this.$emit('row-db-click', row);
        },
        // 搜索内容变化
        searchChange(data) {
            // this.$refs.page.pageState = false;
            this.$emit('searchChange', data);
            // this.$nextTick(() => {
            //     this.$refs.page.pageState = true;
            // });
        },
        // 分页器改变触发事件
        pageChange(page) {
            this.$emit('pageChange', page);
        },
        sizeChange(size) {
            this.$emit('sizeChange', size);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': this.resourceCode
                };
                getList.post(this.configurationUrl, pramas).then(() => {});
                this.tableList = tabelConfigList;
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle() {
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': this.resourceCode,
                    'subjectType': this.pageID
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = allColumns;
                    }
                }).catch(() => {
                    this.checkedList = allColumns;
                });
            }
        },
        initTitleList() {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
            } else {
                this.tableList = this.checkedList;
            }
        },
        getTitleList() {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch(data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance(prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        columnFilterSearch(data) {
            this.$refs.searchList.onSearchChange(data);
        },
        statusChange(status) {
            this.$refs.table.changeStatu(status);
        },
        changeLoading(status) {
            this.$refs.searchList.changeLoading(status);
        },
        moreAction(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        rootListClick(item, to, index) {
            this.$emit('root-click', item, to);
            if (to === 'source') {
                this.sourceCurrent = to + index;
            } else if (to === 'target') {
                this.targetCurrent = to + index;
            }
        },
        targetTableEndMove(moveHeight) {
            const targetTabelEl = document.getElementById('mPanel4').getElementsByClassName('source-table');
            const targetTabelE2 = document.getElementById('mPanel4').getElementsByClassName('table-header');
            targetTabelEl[0].style.height = `calc((100% - 50px)/2 - ${this.endMoveHeight}px - ${moveHeight}px)`;
            targetTabelE2[0].style.height = `calc((100% - 50px)/2 + ${this.endMoveHeight}px + ${moveHeight}px)`;
        },
        mousedownLRWidth(e) {
            this.startMove = e.clientX;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientX;
                if (distance + this.endMoveWidth >= 100) {
                    distance = 0;
                    this.endMoveWidth = 100;
                    return;
                }
                if (distance + this.endMoveWidth <= -80) {
                    distance = 0;
                    this.endMoveWidth = -80;
                    return;
                }
                this.$refs.allTableLeft.style.width = `calc(198px - ${this.endMoveWidth}px - ${distance}px)`;
                this.$refs.allTableRight.style.width = `calc(100% - ${this.$refs.allTableLeft.style.width})`;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveWidth = this.endMoveWidth + distance;
            };
        },
        mousedownlistDragHeight(e) {
            this.startMove = e.clientY;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientY;
                if (distance + this.endListMoveHeight >= 300) {
                    distance = 0;
                    this.endListMoveHeight = 300;
                    return;
                }
                if (distance + this.endListMoveHeight <= -50) {
                    distance = 0;
                    this.endListMoveHeight = -50;
                    return;
                }
                this.$refs.bottomLists.style.height = `calc(88px + ${this.endListMoveHeight}px + ${distance}px)`;
                this.$refs.topLists.style.height = `calc(100vh - 310px - ${this.endListMoveHeight}px - ${distance}px)`;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endListMoveHeight = this.endListMoveHeight + distance;
            };
        },
        initActiveChange() {
            this.sourceCurrent = '';
            this.targetCurrent = '';
            this.input = '';
        },
        sourceCellDblclick(row, column, cell, event) {
            this.$emit('sourceCellDblclick', row, column, cell, event);
        },
        targetCellDblclick(row, column, cell, event) {
            this.$emit('targetCellDblclick', row, column, cell, event);
        },
        targetRowClick(row) {
            this.$emit('targetRowClick', row);
        },
        targetSelect(selection, row) {
            this.$emit('targetSelect', selection, row);
        },
        targetSelectAll(selection) {
            this.$emit('targetSelectAll', selection);
        },
        sourceRowClick(row) {
            this.$emit('sourceRowClick', row);
        },
        sourceSelect(selection, row) {
            this.$emit('sourceSelect', selection, row);
        },
        sourceSelectAll(selection) {
            this.$emit('sourceSelectAll', selection);
        },
        refreshTarget() {
            this.$emit('refreshTarget');
        }
    },
    mounted() {
        this.$refs.allTableLeft.style.width = '198px';
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
    }
};
</script>
<style lang="less">
@import './mpanel.less';
</style>
